interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: () => void;
}

export default function Hero({ query, onQueryChange, onSearch }: HeroProps) {
  return (
    <section className="relative flex h-[560px] w-full items-center justify-center overflow-hidden md:h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=cozy%20warm%20anime%20illustration%20of%20a%20peaceful%20reading%20nook%20with%20a%20steaming%20cup%20of%20milk%20and%20a%20stack%20of%20storybooks%2C%20soft%20plush%20cushions%2C%20warm%20golden%20lamp%20light%2C%20healing%20relaxing%20atmosphere%2C%20pastel%20warm%20colors%2C%20high%20quality%20anime%20background%20art&width=1600&height=900&seq=home-hero&orientation=landscape"
        alt="牛奶动漫库温馨补番氛围插画"
        title="牛奶动漫库 治愈番推荐与日常番合集"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 text-center">
        <span className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-background-50/90 text-primary-600">
          <i className="ri-cup-line text-2xl"></i>
        </span>
        <p className="mb-3 font-brand text-xl text-accent-200 md:text-2xl">
          温馨补番，从这一杯开始
        </p>
        <h1 className="mx-auto max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          治愈番推荐 · 日常番合集 · 萌系动画补番目录
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          在牛奶动漫库，把温馨冷门作与轻松搞笑番都收进收藏夹。按题材与标签分类整理，想找哪部，搜索直达。
        </p>

        <form
          className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full border border-background-200/80 bg-background-50 p-2"
          onSubmit={(e) => {
            e.preventDefault();
            onSearch();
          }}
        >
          <i className="pl-3 text-lg text-foreground-400 ri-search-line"></i>
          <input
            type="text"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="搜索动画名或标签，如 治愈 / 露营 / 搞笑"
            aria-label="搜索动画"
            className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            找番
          </button>
        </form>
      </div>
    </section>
  );
}